import { c as CREATE_USER, d as GET_USERS, b as DELETE_USER, i as SET_CURRENT_USER } from './types-0b7e03a3.js';
import * as qs from 'qs';

var createUser = function createUser(data) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      console.log("DATA: ", data);
      fetch("".concat(process.env.REACT_APP_API_URL.includes("localhost") ? "" : process.env.REACT_APP_API_URL, "/api/v1/users/create"), {
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify(data)
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        dispatch({
          type: CREATE_USER,
          payload: post
        });

        if (!post.ok) {
          reject(post);
        } else {
          resolve(post);
        }
      });
    });
  };
};
var signup = function signup(data) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      console.log("DATA: ", data);
      fetch("".concat(process.env.REACT_APP_API_URL.includes("localhost") ? "" : process.env.REACT_APP_API_URL, "/api/v1/users/signup"), {
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify(data)
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        dispatch({
          type: CREATE_USER,
          payload: post
        });

        if (!post.ok) {
          reject(post);
        } else {
          resolve(post);
        }
      });
    });
  };
};
var getUsers = function getUsers(page, page_size, query) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var parseQuery = qs.stringify(query);
      fetch("".concat(process.env.REACT_APP_API_URL.includes("localhost") ? "" : process.env.REACT_APP_API_URL, "/api/v1/users/?page=").concat(page, "&page_size=").concat(page_size, "&").concat(parseQuery), {
        method: "GET",
        credentials: "include",
        headers: {
          "content-type": "application/json"
        }
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        dispatch({
          type: GET_USERS,
          payload: post
        });

        if (!post.ok) {
          reject(post);
        } else {
          resolve(post);
        }
      });
    });
  };
};
var getUserById = function getUserById(userId) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(process.env.REACT_APP_API_URL.includes("localhost") ? "" : process.env.REACT_APP_API_URL, "/api/v1/users/get/").concat(userId), {
        method: "GET",
        credentials: "include",
        headers: {
          "content-type": "application/json"
        }
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        dispatch({
          type: CREATE_USER,
          payload: post
        });

        if (!post.ok) {
          reject(post);
        } else {
          resolve(post);
        }
      });
    });
  };
};
var deleteUser = function deleteUser(userId) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(process.env.REACT_APP_API_URL.includes("localhost") ? "" : process.env.REACT_APP_API_URL, "/api/v1/users/delete/").concat(userId), {
        method: "DELETE",
        credentials: "include",
        headers: {
          "content-type": "application/json"
        }
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        dispatch({
          type: DELETE_USER,
          payload: post
        });

        if (!post.ok) {
          reject(post);
        } else {
          resolve(post);
        }
      });
    });
  };
};
var updateUser = function updateUser(userId, data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      console.log(data);
      fetch("".concat(process.env.REACT_APP_API_URL, "/api/v1/users/update/").concat(userId), {
        method: "PUT",
        credentials: "include",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify(data)
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        dispatch({
          type: CREATE_USER,
          payload: post
        });

        if (!post.ok) {
          reject(post);
        } else {
          resolve(post);
        }
      });
    });
  };
};
var setCurrentUser = function setCurrentUser(data) {
  return function (dispatch) {
    dispatch({
      type: SET_CURRENT_USER,
      payload: data
    });
  };
};

export { createUser, deleteUser, getUserById, getUsers, setCurrentUser, signup, updateUser };
